<template>
    <div>
        <el-radio-group v-model="radio1" class="tab">
            <el-radio-button label="SIM卡申请"></el-radio-button>
            <el-radio-button label="批量SIM卡申请"></el-radio-button>
            <el-radio-button label="批号SIM卡申请"></el-radio-button>
        </el-radio-group>

        <!--SIM卡申请-->
        <el-form v-show="radio1=='SIM卡申请'" :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
            <el-form-item label="SIM卡号" prop="simId">
                <el-input placeholder="请输入SIM卡号" v-model="rule.simId" clearable></el-input>
            </el-form-item>
            <el-form-item label="开始日期" prop="start">
                <el-date-picker
                    v-model="rule.start"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择开始日期" :picker-options="OptStart1">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期" prop="end">
                <el-date-picker
                    v-model="rule.end"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择结束日期" :picker-options="OptEnd1">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">提交</el-button>
                <el-button @click="block">返回</el-button>
            </el-form-item>
        </el-form>
        <!--End:SIM卡申请-->

        <!--批量SIM卡申请-->
        <el-form v-show="radio1=='批量SIM卡申请'" :model="rule2" :rules="rules2" ref="forms2" class="demo-ruleForm" label-width="100px">
            <el-form-item label="选择文件" prop="file">
                <input type="file" name="file" @change="getFile($event)">
            </el-form-item>
            <el-form-item label="开始日期" prop="start">
                <el-date-picker
                    v-model="rule2.start"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择开始日期" :picker-options="OptStart2">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期" prop="end">
                <el-date-picker
                    v-model="rule2.end"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择结束日期" :picker-options="OptEnd2">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit2">提交</el-button>
                <el-button @click="block">返回</el-button>
            </el-form-item>
        </el-form>
        <!--END:批量SIM卡申请-->

        <!--批号SIM卡申请-->
        <el-form v-show="radio1=='批号SIM卡申请'" :model="rule3" :rules="rules3" ref="forms3" class="demo-ruleForm" label-width="100px">
            <el-form-item label="批号" prop="batch">
                <el-select v-model="rule3.batch">
                    <el-option value="" label="请选择批号"></el-option>
                    <el-option v-for="x in selectList" :key="x" :value="x" :label="x"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始日期" prop="start">
                <el-date-picker
                    v-model="rule3.start"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择开始日期" :picker-options="OptStart3">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期" prop="end">
                <el-date-picker
                    v-model="rule3.end"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择结束日期" :picker-options="OptEnd3">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit3">提交</el-button>
                <el-button @click="block">返回</el-button>
            </el-form-item>
        </el-form>
        <!--END:批号SIM卡申请-->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                name: 'edit',
                radio1:'SIM卡申请',
                rule: {
                    simId: '',
                    start: '',
                    end: '',
                },
                rules: {
                    simId: { required: true, message: '请输入SIM卡号' },
                    start: {required: true, message: '选择开始日期'},
                    end: {required: true, message: '选择结束日期'},
                },
                rule2: {
                    file: '',
                    start: '',
                    end: '',
                },
                rules2: {
                    file: { required: true, message: '请选择文件' },
                    start: {required: true, message: '选择开始日期'},
                    end: {required: true, message: '选择结束日期'},
                },
                selectList:[],
                rule3: {
                    batch: '',
                    start: '',
                    end: '',
                },
                rules3: {
                    batch: { required: true, message: '请选择批号' },
                    start: {required: true, message: '选择开始日期'},
                    end: {required: true, message: '选择结束日期'},
                },
                //时间限制
                OptStart1:{
                    disabledDate:time=> {
                        if(this.rule.end) {
                            return time.getTime() >= new Date(this.rule.end).getTime()
                        }
                    }
                },
                OptEnd1:{
                    disabledDate:time=> {
                        if(this.rule.start) {
                            return time.getTime() <= new Date(this.rule.start).getTime()
                        }
                    }
                },
                OptStart2:{
                    disabledDate:time=> {
                        if(this.rule2.end) {
                            return time.getTime() >= new Date(this.rule2.end).getTime()
                        }
                    }
                },
                OptEnd2:{
                    disabledDate:time=> {
                        if(this.rule2.start) {
                            return time.getTime() <= new Date(this.rule2.start).getTime()
                        }
                    }
                },
                OptStart3:{
                    disabledDate:time=> {
                        if(this.rule3.end) {
                            return time.getTime() >= new Date(this.rule3.end).getTime()
                        }
                    }
                },
                OptEnd3:{
                    disabledDate:time=> {
                        if(this.rule3.start) {
                            return time.getTime() <= new Date(this.rule3.start).getTime()
                        }
                    }
                },
            }
        },
        created() {
            this.$http.get('/manage/sim/batchList').then(results => {
                this.selectList = results['data']['data'];
            });
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        this.rule.start = this.rule.start.replace(/-/g,'');
                        this.rule.end = this.rule.end.replace(/-/g,'');
                        this.$http.post('/manage/pay/add',this.rule).then(rs => {
                            if(rs.data.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.$router.push('/sim/pay');
                            }else {
                                this.$message({
                                    message: rs.data.message,
                                    type: 'error'
                                });
                            }
                        })
                    }
                });
            },
            submit2() {
                this.$refs['forms2'].validate(valid => {
                    if(valid) {
                        let headers = {
                            'Content-Type': 'multipart/form-data'
                        };
                        let formData = new FormData();
                        formData.append('file',this.rule2.file);
                        formData.append('start',this.rule2.start.replace(/-/g,''));
                        formData.append('end',this.rule2.end.replace(/-/g,''));
                        this.$http.post('/manage/pay/addByExcel',formData,{headers:headers}).then(rs => {
                            if(rs.data.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.$router.push('/sim/pay');
                            }else {
                                this.rule2.file = '';
                                this.$message({
                                    message: rs.data.message,
                                    type: 'error'
                                });
                            }
                        })
                    }
                });
            },
            submit3() {
                this.$refs['forms3'].validate(valid => {
                    if(valid) {
                        this.rule3.start = this.rule3.start.replace(/-/g,'');
                        this.rule3.end = this.rule3.end.replace(/-/g,'');
                        this.$http.post('/manage/pay/addByBatch',this.rule3).then(rs => {
                            if(rs.data.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.$router.push('/sim/pay');
                            }else {
                                this.$message({
                                    message: rs.data.message,
                                    type: 'error'
                                });
                            }
                        })
                    }
                });
            },
            getFile(event){
                var file = event.target.files;
                for(var i = 0;i<file.length;i++){
                    //    上传类型判断
                    var imgName = file[i].name;
                    var idx = imgName.lastIndexOf(".");  
                    if (idx != -1){
                        var ext = imgName.substr(idx+1).toUpperCase();   
                        ext = ext.toLowerCase(); 
                        this.rule2.file = file[i];
                    }
                }
            },
            block() {
                this.$router.go(-1);
            },
        }
    }
</script>
<style scoped>
.tab{margin-bottom: 20px; margin-left: 100px;}
</style>